// if: lines of code > 300
// then: breakdown this file and move to repoV2/features/OfferingVariationSelector/ folder
import { DropdownSelector } from "@Modules/common/Form";
import React from "react";
import { checkIsArrayEmpty } from "@my-scoot/exly-react-component-lib";
import commonStyles from "../commonStyles.module.scss";
import { SidebarSectionDivider } from "../SidebarSectionDivider";
import { useOfferingVariations } from "./useOfferingVariations";

export const OfferingVariationSelector = () => {
    const {
        fetchOfferingVariations,
        offeringVariations,
        selectedVariation,
        handleOnChange,
        sectionTitle,
        is_offering_variants_enabled,
    } = useOfferingVariations();

    React.useEffect(() => {
        fetchOfferingVariations();
    }, []);

    if (!is_offering_variants_enabled || checkIsArrayEmpty(offeringVariations))
        return null;

    return (
        <>
            <div className={commonStyles.sidebarSectionTitle}>
                {sectionTitle}
            </div>

            <DropdownSelector
                value={selectedVariation}
                placeholder="Select a plan"
                options={offeringVariations}
                // className={classNames(showInputError && styles.dropdownError)}
                onChange={handleOnChange}
            />
            <SidebarSectionDivider />
        </>
    );
};
